import { useMsal } from '@azure/msal-react';
import { Button, Subtitle1 } from '@fluentui/react-components';
import { ArrowRight20Regular } from '@fluentui/react-icons';
import EricssonLogo from '@/coral/imports/EricssonLogo';
import { signIn } from '@/auth/authActions';

interface SignedOutProps {
    clientId: string;
}

const SignedOut: React.FC<SignedOutProps> = ({ clientId }) => {
    const { instance } = useMsal();

    const handleSignIn = async () => {
        await signIn(instance, clientId);
    };

    return (
        <main
            style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                height: '100vh',
                justifyContent: 'center',
            }}
        >
            <EricssonLogo />
            <Subtitle1>You're signed out</Subtitle1>
            <Button appearance="primary" icon={<ArrowRight20Regular />} onClick={handleSignIn}>
                Sign in
            </Button>
        </main>
    );
};

export default SignedOut;
